export default "__VITE_ASSET__Baogla5U__"